import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import DirectMessaging from './PageFrameHeaderNavigation/DirectMessaging'

import { Link } from 'react-router-dom'

import withContext from 'components/RealtimeMessagingProvider/withContext'

import { actions } from 'store/messaging'

export class AdmissionsDirectMessaging extends React.Component {
  static propTypes = {
    hasUnreadMessage: PropTypes.bool.isRequired,
    userId: PropTypes.string.isRequired,
    turnOnUnreadMessageFlag: PropTypes.func.isRequired,
    populateUnreadMessageFlag: PropTypes.func.isRequired,
    realtimeConnect: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.props.populateUnreadMessageFlag()
    this.props.realtimeConnect(`${this.props.userId}-MessageCentre`, (newMessage) => {
      if (newMessage.Message.SenderId !== this.props.userId) {
        this.props.turnOnUnreadMessageFlag()
      }
    })
  }

  render() {
    const ROOT = import.meta.env.BASE_URL
    return (
      <Link to={`${ROOT}/message-center/messages`}>
        <DirectMessaging
          theme="light"
          hasUnreadMessage={this.props.hasUnreadMessage}
        />
      </Link>
    )
  }
}

const RealtimeMessagingConnected = withContext({
  connect: 'realtimeConnect',
})(AdmissionsDirectMessaging)

export default connect(
  (state) => ({
    userId: state.user.record.Id,
    hasUnreadMessage: state.messaging.hasUnreadMessage,
  }),
  {
    turnOnUnreadMessageFlag: actions.turnOnUnreadMessageFlag,
    populateUnreadMessageFlag: actions.populateUnreadMessageFlag,
  },
)(RealtimeMessagingConnected)
